import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="py-20 px-4 bg-[#0a0a1a] relative" data-id="element-45">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-46"></div>

      <div className="max-w-4xl mx-auto" data-id="element-47">
        <div className="bg-gradient-to-b from-gray-900 to-gray-800 border-2 border-gold rounded-3xl p-8 md:p-12 text-center relative shadow-[0_0_50px_rgba(212,168,67,0.15)]" data-id="element-48">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-gold text-black font-black px-8 py-2 rounded-full text-lg shadow-lg" data-id="element-49">
            OFERTA ESPECIAL
          </div>

          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 mt-4" data-id="element-50">
            Accedé ahora a Entrenador de Futsal 360°
          </h2>

          <p className="text-xl text-gray-300 mb-10" data-id="element-51">
            Sistema Completo + 3 Bonos Exclusivos
          </p>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-52">
            <p className="text-gray-400 text-lg mb-2" data-id="element-53">Precio Normal:</p>
            <p className="text-3xl md:text-4xl text-red-500 font-bold line-through decoration-4 mb-4" data-id="element-54">
              $49.990
            </p>
            <p className="text-gray-300 text-lg mb-2" data-id="element-55">Precio por hoy:</p>
            <p className="text-6xl md:text-7xl font-black text-gold drop-shadow-lg" data-id="element-56">
              $19.990
            </p>
            <p className="text-sm text-gray-400 mt-2" data-id="element-57">Pesos Argentinos</p>
          </div>

          <motion.a href="https://checkout.abastecedordigital.shop/cart/51783338262848:1" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="block w-full max-w-xl mx-auto bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-black text-xl md:text-2xl py-6 px-8 rounded-2xl shadow-[0_0_30px_rgba(34,197,94,0.4)] transition-all uppercase tracking-wider mb-8" data-id="element-58">
            COMPRAR AHORA
          </motion.a>

          <div className="flex flex-wrap justify-center gap-6 text-gray-400 text-sm font-medium" data-id="element-59">
            <div className="flex items-center gap-2" data-id="element-60">
              <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-61" />
              <span data-id="element-62">Compra 100% Segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-63">
              <Lock className="w-5 h-5 text-green-500" data-id="element-64" />
              <span data-id="element-65">Privacidad Garantizada</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-66">
              <CreditCard className="w-5 h-5 text-green-500" data-id="element-67" />
              <span data-id="element-68">Múltiples medios de pago</span>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center space-y-6 max-w-2xl mx-auto" data-id="element-69">
          <p className="text-2xl font-bold text-white" data-id="element-70">Empezá hoy mismo.</p>
          <p className="text-xl text-gray-300" data-id="element-71">
            Y en pocas semanas… vas a notar la diferencia:
          </p>
          <p className="text-xl font-bold text-gold" data-id="element-72">
            En la cancha. En tu equipo. Y en cómo te ven como entrenador.
          </p>
          <p className="text-2xl font-black text-white mt-8" data-id="element-73">
            👉 Entrá ahora y empezá a entrenar con un sistema real
          </p>
        </div>
      </div>
    </section>;
}